// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__5xbEp","pulse":"styles_pulse__7x5yF","jump":"styles_jump__IIQjW"};